<template>
  <div class="order">
    <div class="p-title">CPR+广告投放</div>
    <div class="p-main">
      <div class="put_tabs" v-show="!isConfirm">
        <span
          v-for="{ tab, title } in tabItems"
          :class="['put_tab_pane', {'act': tab === curTab}]"
          :key="tab"
          @click="tabSelect(tab)">
          {{ title }}
        </span>
      </div>
      <CprPlusContainer v-if="renderFlag" :isImport="isImport" :importType="importType" @showConfirm="handleConfirm"></CprPlusContainer>
    </div>
  </div>
</template>

<script>
import CprPlusContainer from './CprPlusContainer'

export default {
  name: 'PutCprPlus',
  components: { CprPlusContainer },
  data() {
    return {
      isConfirm: false,
      tabItems: [
        {
          title: '条件搜索',
          tab: 'putCpr+'
        }, {
          title: '导入小区',
          tab: 'communityImport'
        }, {
          title: '导入点位',
          tab: 'deviceImport'
        }
      ],
      curTab: 'putCpr+',
      renderFlag: true
    }
  },
  computed: {
    isImport () {
      return this.curTab.indexOf('Import') > 0
    },
    importType () {
      return this.curTab.replace('Import', '')
    }
  },
  beforeDestroy() {
    window.$listCopy = null
    delete window.$listCopy
    this.pageInit()
  },
  async created() {
    if (!this.$store.state.common.advertTypes || !this.$store.state.common.advertTypes.length) {
      await this.$store.dispatch('getAdvertType')
    }
    this.pageInit()
  },
  methods: {
    pageInit() {
      const { tab } = this.tabItems[0]
      this.$store.commit('order/setCoditionSearchType', tab || '') // 初始设置状态为条件筛选
    },
    tabSelect(name) {
      if (name === this.curTab) return
      this.curTab = name
      this.$store.commit('order/setCoditionSearchType', name)
      this.renderFlag = false
      this.$nextTick(() => {
        this.renderFlag = true
      })
    },
    handleConfirm(v) {
      this.isConfirm = v
    }
  }
}
</script>

<style lang="scss" scoped>
.put_tabs {
  height: 50px;
  padding: 0 10px;
  background-color: #f5f5f5;
  box-shadow: 0 -1px 0 0 #d4d4d4 inset;
}
.put_tab_pane {
  display: inline-block;
  padding: 9px 28px;
  margin-top: 8px;
  margin-left: 10px;
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  background-color: #F5F5F5;
  border: 1px solid #D4D4D4;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  &:hover {
    color: #000;
  }
  &.act {
    color: #282729;
    background-color: #FFFFFF;
    border-bottom-color: #fff;
    font-weight: bolder;
  }
}
</style>
